/**
 * Home — 인증이지 랜딩 페이지 (new design)
 *
 * preview/index.html 1:1 매칭. 섹션 순서:
 *   Header → Hero → Services → WhyUs → Benefits → Process → Compare → HowWeHelp → Contact → FAQ → Footer
 *   + B2BModal (헤더 'B2B 접수' 버튼 클릭 시 표시)
 *
 * CSS 격리:
 *   - 모든 랜딩 스타일은 .landing-root 스코프 안에서만 적용됨
 *   - landing.css가 전역 import 되어도 어드민(/admin/*)에는 영향 없음
 *
 * 라우팅:
 *   - /        → 이 컴포넌트
 *   - /terms   → Terms (별도)
 *   - /admin/* → 어드민 (RequireAdmin 가드)
 */
import { useCallback, useState } from 'react';
import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';
import { Hero } from '@/components/landing/Hero';
import { Services } from '@/components/landing/Services';
import { WhyUs } from '@/components/landing/WhyUs';
import { Benefits } from '@/components/landing/Benefits';
import { Process } from '@/components/landing/Process';
import { Compare } from '@/components/landing/Compare';
import { HowWeHelp } from '@/components/landing/HowWeHelp';
import { InboundForm } from '@/components/landing/InboundForm';
import { FAQ } from '@/components/landing/FAQ';
import { B2BModal } from '@/components/landing/B2BModal';

export function Home() {
  const [b2bOpen, setB2bOpen] = useState(false);

  /** Contact 폼(#contact)으로 스크롤 — Hero CTA, Services 카드 CTA 공용 */
  const scrollToContact = useCallback(() => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className="landing-root">
      <Header onOpenB2B={() => setB2bOpen(true)} />

      <main>
        <Hero onCTA={scrollToContact} />
        <Services onSelect={scrollToContact} />
        <WhyUs />
        <Benefits />
        <Process />
        <Compare />
        <HowWeHelp />
        <InboundForm />
        <FAQ />
      </main>

      <Footer />

      <B2BModal open={b2bOpen} onClose={() => setB2bOpen(false)} />
    </div>
  );
}
